import React from 'react';
import { Icon, Table, Label, Image } from 'semantic-ui-react';
import moment from 'moment';
import _ from 'lodash';
import numeral from 'numeral';
import { mapPostData } from '../../utils/instagram';

const cf = num => numeral(num).format('0,0');
const atMentionRegex = /(@\w+\b)/g;

const ListLayout = ({ items, allPosts, smallImages }) => (
  <Table celled fluid basic="very" textAlign="center">
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell>Platform</Table.HeaderCell>
        <Table.HeaderCell>#ad?</Table.HeaderCell>
        <Table.HeaderCell>Post</Table.HeaderCell>
        <Table.HeaderCell textAlign="left">Text</Table.HeaderCell>
        <Table.HeaderCell>Published</Table.HeaderCell>
        <Table.HeaderCell>Likes</Table.HeaderCell>
        <Table.HeaderCell>Comments</Table.HeaderCell>
        <Table.HeaderCell>Brand</Table.HeaderCell>
      </Table.Row>
    </Table.Header>

    <Table.Body>
      {
        _.map(items, item => {
          const post = mapPostData(item.postData);
          if (!allPosts && !item.isAd) return null;

          const relativeTime = post && moment(post.date * 1000).fromNow();
          const atMatches = post && _.uniqBy(post.caption.match(atMentionRegex));

          const imageSize = smallImages ? 'tiny' : 'medium';
          const captionLength = smallImages ? 500 : 1000;

          return (
            <Table.Row>
              <Table.Cell><Icon name="instagram" color="pink" size="big" /></Table.Cell>
              <Table.Cell>{ item.isAd && <Icon name="money" color="green" size="big" />}</Table.Cell>
              <Table.Cell>
                <a
                  href={`https://www.instagram.com/p/${item.instagramCode}/`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Image size={imageSize} src={post && post.display_src} />
                </a>
              </Table.Cell>
              <Table.Cell textAlign="left">
                { post && _.truncate(post.caption, { length: captionLength, separator: ' ' }) }
              </Table.Cell>
              <Table.Cell>{relativeTime}</Table.Cell>
              <Table.Cell>{ post && cf(post.likes.count)}</Table.Cell>
              <Table.Cell>{ post && cf(post.comments.count)}</Table.Cell>
              <Table.Cell>
                {
                  atMatches &&
                  _.map(atMatches, handle => (
                    <Label color="pink" basic content={handle} />
                  ))
                }
              </Table.Cell>
            </Table.Row>
          );
        })
      }
    </Table.Body>
  </Table>
);

export default ListLayout;



/** WEBPACK FOOTER **
 ** ./src/components/influencer-ad-posts/list-layout.js
 **/